import { CountriesType, LanguagesType } from '../types/common.types';

export const COUNTRY_LIST: Record<CountriesType, { name: string }> = {
  se: { name: 'Sweden' },
  fi: { name: 'Finland' },
  no: { name: 'Norway' },
  dk: { name: 'Denmark' },
  gb: { name: 'UnitedKingdom' },
  nl: { name: 'Netherlands' },
  at: { name: 'Austria' },
  pl: { name: 'Poland' },
  lt: { name: 'Lithuania' }
};

export const LANGUAGE_LIST: Record<LanguagesType, { name: string }> = {
  sv: { name: 'Swedish' },
  no: { name: 'Norwegian' },
  pl: { name: 'Polish' },
  da: { name: 'Danish' },
  nl: { name: 'Dutch' },
  en: { name: 'English' },
  sk: { name: 'Slovak' },
  fo: { name: 'Faroese' }
};
